export default {
  pkf: {
    label: 'PKF Form',
    component: () => import('./pfk-form/index')
  },
  standroll: {
    label: 'Stand & Roll Form',
    component: () => import('./standroll-form/index')
  },
  runner: {
    label: 'Runner Form',
    component: () => import('./runner-form/index')
  },
  std_seat: {
    label: 'Standard Seat Form',
    component: () => import('./std-seat-form/index')
  },
  custom_seat: {
    label: 'Custom Milled Seat Form',
    component: () => import('./custom-seat-form/index')
  },
  abs_thermo: {
    label: 'ABS Thermoforming Form',
    component: () => import('./abs-thermo-form/index')
  },
  upholstry: {
    label: 'Uhpolstry Form',
    component: () => import('./upholstry/index')
  },
  parts_form: {
    label: 'Parts Form',
    component: () => import('./parts-form/index')
  }
}
